import EditPieceSidePane from "./EditPieceSidePane";
export default EditPieceSidePane;
